import { useState, useEffect } from 'react';
import { Search, Filter,ChevronDown  } from "lucide-react";
import { useNavigate } from 'react-router-dom';
import { Package} from "lucide-react";
import { decryptData } from '../../../utils/storageCrypto';
import Pagination, { usePagination } from '../../Components/Pagination';

export default function OrdersManager() {
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [openItemsPopup, setOpenItemsPopup] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedOrders, setSelectedOrders] = useState([]);
const [selectedGroups, setSelectedGroups] = useState([]);
const [showCancelConfirm, setShowCancelConfirm] = useState(false);
const [awardPopupOpen, setAwardPopupOpen] = useState(false);
const [selectedSuppliers, setSelectedSuppliers] = useState([]);
const [suppliers, setSuppliers] = useState([]);
const [awardLoading, setAwardLoading] = useState(false);
const [showStatusDropdown, setShowStatusDropdown] = useState(false);
const [selectedStatus, setSelectedStatus] = useState([]);
const [cancelType, setCancelType] = useState(null); 
const [selectedBillingStatus, setSelectedBillingStatus] = useState([]);
const [showBillingStatusDropdown, setShowBillingStatusDropdown] = useState(false);


const STATUS_OPTIONS = [
  "Waiting for Delivery Schedule",
  "Ready For Delivery",
  "Out For Delivery",
  "Delivered",
  "Returned",
  "Cancelled"
];


const STATUS_COLORS = {
  "Not Billed": "text-red-600 bg-red-50",
  "Billed": "text-green-600 bg-green-50",
  "Partially Billed": "text-yellow-600 bg-yellow-50",
  "Ready To Bill": "text-orange-600 bg-orange-50",
  "Waiting for Delivery Schedule": "text-yellow-600 bg-yellow-50",
  "Ready For Delivery": "text-teal-700 bg-teal-50",
  "Out For Delivery": "text-purple-600 bg-purple-50",
  "Delivered": "text-green-700 bg-green-50",
  "Returned": "text-red-700 bg-red-50",
  "Cancelled": "text-gray-500 bg-gray-50",
  "Order Placed": "text-yellow-600 bg-yellow-50"
};

 const BILLING_STATUS_OPTIONS = [
  "Not Billed",
  "Billed",
  "Ready To Bill",
  "Partially Billed"
];

  useEffect(() => {
    fetchDeliveryGroupData();
  }, []);

  const fetchDeliveryGroupData = async () => {
    try {
      setLoading(true);
      const fetchUrl = process.env.REACT_APP_FORE_BRICKBUCKET;
      const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);


      const response = await fetch(
        `${fetchUrl}customer/salesorder/get-all-customer-orders`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'x-token': token
          }
        }
      );

      const data = await response.json();
      
      console.log('Fetched Orders:', data);
      if (response.ok) {
        setOrders(data.data || []);
      }
    } catch (error) {
      console.error('Failed to fetch orders:', error);
    } finally {
      setLoading(false);
    }
  };

 const handleNavigateToDeliveryDetails = (deliveryGroupId, order) => {
  navigate('/bb/app/orderfullfillmentflow', {
    state: {
      delivery_group_id: deliveryGroupId,        // clicked group
      order_data: order,                         // order info
      all_delivery_groups: order.filteredGroups  // ✅ ALL groups
    }
  });
};


// const filterDeliveryGroups = (groups, order) => {
//   return groups.filter((dg) => {

//     const safe = (val) =>
//       val === undefined || val === null ? "" : String(val).toLowerCase().trim();

//     const deliveryStatus = safe(dg?.delivery_group_status);
//     const billingStatus =
//       safe(dg?.billing_status) || safe(dg?.delivery_group_billing_status);

//     /* ================= STATUS FILTER ================= */

//     // ✅ MULTI SELECT STATUS LOGIC
//     if (selectedStatus && selectedStatus.length > 0) {
//       const statusMatch = selectedStatus.some((status) => {
//         const s = status.toLowerCase();
//         return deliveryStatus === s || billingStatus === s;
//       });

//       if (!statusMatch) return false;
//     }

//     /* ================= SEARCH FILTER ================= */

//     if (searchText && searchText.trim() !== "") {
//       const text = searchText.toLowerCase().trim();

//       const match =
//         safe(order?.orderNumber).includes(text) ||
//         safe(dg?.delivery_group_number).includes(text) ||
//         safe(order?.customer?.name).includes(text) ||
//         safe(order?.customer?.mobile).includes(text) ||
//         deliveryStatus.includes(text) ||
//         billingStatus.includes(text);

//       if (!match) return false;
//     }

//     return true;
//   });
// };


const filterDeliveryGroups = (groups, order) => {
  return groups.filter((dg) => {

    const safe = (val) =>
      val === undefined || val === null ? "" : String(val).toLowerCase().trim();

    const deliveryStatus = safe(dg?.delivery_group_status);
    const billingStatus =
      safe(dg?.billing_status || dg?.delivery_group_billing_status);

    /* ================= STATUS FILTER ================= */
    if (selectedStatus && selectedStatus.length > 0) {
      const statusMatch = selectedStatus.some((status) => {
        const s = status.toLowerCase();
        return deliveryStatus === s || billingStatus === s;
      });

      if (!statusMatch) return false;
    }

    /* ================= BILLING STATUS FILTER (FIX) ================= */
    if (selectedBillingStatus && selectedBillingStatus.length > 0) {
      const billingMatch = selectedBillingStatus.some((status) => {
        return billingStatus === status.toLowerCase();
      });

      if (!billingMatch) return false;
    }

    /* ================= SEARCH FILTER ================= */
    if (searchText && searchText.trim() !== "") {
      const text = searchText.toLowerCase().trim();

      const match =
        safe(order?.orderNumber).includes(text) ||
        safe(dg?.delivery_group_number).includes(text) ||
        safe(order?.customer?.name).includes(text) ||
        safe(order?.customer?.mobile).includes(text) ||
        deliveryStatus.includes(text) ||
        billingStatus.includes(text);

      if (!match) return false;
    }

    return true;
  });
};

const toggleStatus = (status) => {
  setSelectedStatus(prev =>
    prev.includes(status)
      ? prev.filter(s => s !== status)
      : [...prev, status]
  );
};

const toggleSelectAll = () => {
  if (selectedStatus.length === STATUS_OPTIONS.length) {
    setSelectedStatus([]);
  } else {
    setSelectedStatus(STATUS_OPTIONS);
  }
};

const clearAll = () => {
  setSelectedStatus([]);
};
useEffect(() => {
  const handleOutside = (e) => {
    if (!e.target.closest(".status-dropdown")) {
      setShowStatusDropdown(false);
    }
  };

  document.addEventListener("mousedown", handleOutside);
  return () => document.removeEventListener("mousedown", handleOutside);
}, []);

const toggleGroupSelect = (groupId, order) => {
  setSelectedGroups(prevGroups => {
    const isCurrentlySelected = prevGroups.includes(groupId);
    const nextGroups = isCurrentlySelected 
      ? prevGroups.filter(id => id !== groupId) 
      : [...prevGroups, groupId];

    // CHECK SYNC: Should the main Order checkbox be checked?
    // We check if ALL filtered groups of this order are present in the NEW selection state
    const allFilteredGroupIds = order.filteredGroups.map(g => g._id);
    const areAllGroupsSelected = allFilteredGroupIds.every(id => nextGroups.includes(id));

    setSelectedOrders(prevOrders => {
      if (areAllGroupsSelected) {
        // Add order ID if not already present
        return prevOrders.includes(order._id) ? prevOrders : [...prevOrders, order._id];
      } else {
        // Remove order ID because at least one group is unchecked
        return prevOrders.filter(id => id !== order._id);
      }
    });

    return nextGroups;
  });
};


const toggleOrderSelect = (orderId, deliveryGroups) => {
  setSelectedOrders(prevOrders => {
    const isSelected = prevOrders.includes(orderId);
    let newOrders;

    if (isSelected) {
      // Deselect order
      newOrders = prevOrders.filter(id => id !== orderId);
    } else {
      // Select order
      newOrders = [...prevOrders, orderId];
    }

    // Update selectedGroups accordingly
    setSelectedGroups(prevGroups => {
      const groupIds = deliveryGroups.map(g => g._id);

      if (isSelected) {
        // Deselect all groups for this order
        return prevGroups.filter(id => !groupIds.includes(id));
      } else {
        // Select all groups for this order
        return [...new Set([...prevGroups, ...groupIds])];
      }
    });

    return newOrders;
  });
};


const hasAnySelection =
  selectedOrders.length > 0 || selectedGroups.length > 0;

const toggleSupplierSelection = (vendorId) => {
  setSelectedSuppliers(prev =>
    prev.includes(vendorId)
      ? prev.filter(id => id !== vendorId)
      : [...prev, vendorId]
  );
};


const getCancelButtonText = () => {
  if (selectedOrders && selectedOrders.length > 0) {
    return "Cancel Order";
  }

  if (selectedGroups && selectedGroups.length > 0) {
    return "Cancel Delivery Group";
  }

  return "";
};


  const handleItemsClick = (e, deliveryGroup) => {
    console.log("Opening items popup for delivery group:", deliveryGroup);
    e.stopPropagation();
    // Include context (sub-order id, delivery group id, PO id) and add local availability state
    const items =
      deliveryGroup.sub_orders?.flatMap(sub =>
        (sub.items || []).map(item => {
          const supplier = sub.vendor_id || sub.vendor || null;
          const originalItemVendor = item.item_vendor || null;
          return {
            ...item,
            // Preserve item-level vendor (if any). For display, fallback item_vendor to supplier when missing.
            item_vendor: originalItemVendor || supplier,
            // Keep explicit supplier (sub-order vendor) always so we can show both
            supplier,
            // Parent references for actions
            sub_order_id: sub._id,
            delivery_group_id: deliveryGroup._id,
            purchaseorder_id: sub.purchaseorder_id || sub.po_id || null,
            // Local UI state defaults
            // available: true,
            availableQty: Number(item.receivable_quantity),
            original_quantity: Number(item.quantity),
            salesorder_id: deliveryGroup.salesorder_id,
            item_status: item.item_status,
            delivery_group_status: deliveryGroup.delivery_group_status,

          };
        })
      ) || [];

      console.log("Items for availability popup:", items);

    setSelectedItems(items);
    setOpenItemsPopup(true);
  };

  const getTotalItemsCount = (deliveryGroup) => {
    if (!deliveryGroup?.sub_orders) return 0;
    return deliveryGroup.sub_orders.reduce(
      (total, sub) => total + (sub.items?.length || 0),
      0
    );
  };

  // --- Helpers for item availability and actions ---
  const updateSelectedItem = (itemId, updater) => {
    setSelectedItems(prev => prev.map(it => it._id === itemId ? { ...it, ...updater(it) } : it));
  };

  const toggleItemAvailability = (itemId) => {
    updateSelectedItem(itemId, (it) => ({ available: !it.available, availableQty: !it.available ? it.quantity : 0 }));
  };

const setItemAvailableQty = (itemId, qty) => {

  // Allow full empty delete
  if (qty === "" || qty === null) {
    updateSelectedItem(itemId, () => ({
      availableQty: "",
      available: false
    }));
    return;
  }

  const num = Number(qty);

  // If not valid number → keep empty
  if (isNaN(num)) {
    updateSelectedItem(itemId, () => ({
      availableQty: "",
      available: false
    }));
    return;
  }

  // ✅ NO Math.min → NO restriction
  updateSelectedItem(itemId, () => ({
    availableQty: num,
    available: num > 0
  }));
};

// --- AWARD SUPPLIER ---
const handleAwardSupplier = async () => {
  const selectedItemIds = selectedItems
    .filter(i => i.available)
    .map(i => i._id);

  if (selectedItemIds.length === 0) {
    alert("No items selected to award supplier.");
    return;
  }

  try {
    const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);

    const order_id = selectedItems[0].salesorder_id;
    const shipment_id = selectedItems[0].delivery_group_id;

    console.log("Awarding supplier with payload:", {
      order_id,
      shipment_id,
      item_ids: selectedItemIds,
    });

    const response = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/salesorder/award-items-to-vendors-and-create-suborders`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-token": token,
        },
        body: JSON.stringify({
          salesOrderId:order_id,
          deliveryGroupId: shipment_id,
          selectedItems: selectedItems.filter(i => i.available),  // Only send checked (available) items
          selectedSuppliers: selectedSuppliers,
        }),
      }
    );
  

    const data = await response.json();
    console.log("Award Supplier Response:", data);
    if (data.success) {
      alert("Supplier awarded successfully!");
      setAwardPopupOpen(false);
      setOpenItemsPopup(false);
      fetchDeliveryGroupData();
    } else {
      alert(data.message || "Failed to award supplier");
    }
  } catch (err) {
    console.error("Award supplier error:", err);
    alert("Something went wrong while awarding supplier");
  }
};

// --- REMOVE SELECTED ITEMS ---
const handlecancelSelectedItems = async () => {
  const selectedItemIds = selectedItems
    .filter(i => i.available)
    .map(i => i._id);

  if (selectedItemIds.length === 0) {
    alert("No items selected to remove.");
    return;
  }

  if (!window.confirm("Are you sure you want to remove the selected items?")) return;

  try {
    const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);

    //const order_id = selectedItems[0].purchaseorder_id;
    const shipment_id = selectedItems[0].delivery_group_id;

    const response = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/salesorder/cancel-items-or-quantity-in-deliverygroup`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-token": token,
        },
        body: JSON.stringify({
          //order_id,
          delivery_group_id: shipment_id,
          items: selectedItems.filter(i => i.available),  // Only send checked (available) items
        }),
      }
    );

    const data = await response.json();
    if (data.success) {
      alert("Selected items Removed successfully!");
      setOpenItemsPopup(false);
      fetchDeliveryGroupData();
    } else {
      alert(data.message || "Failed to Remove items");
    }
  } catch (err) {
    console.error("Remove items error:", err);
    alert("Something went wrong while Removing items");
  }
};

// --- SAVE SELECTED ITEMS ---
const handlesaveSelectedItems = async () => {
  const selectedData = selectedItems
    .filter(i => i.available)
    .map(i => ({
      item_id: i._id,
      quantity: i.availableQty,
      sub_order_id: i.sub_order_id,
    }));

  if (selectedData.length === 0) {
    alert("No items selected to save.");
    return;
  }

  try {
    const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);

    const order_id = selectedItems[0].purchaseorder_id;
    const shipment_id = selectedItems[0].delivery_group_id;

    const response = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/salesorder/save-selected-items`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-token": token,
        },
        body: JSON.stringify({
          order_id,
          shipment_id,
          items: selectedData,
        }),
      }
    );

    const data = await response.json();
    if (data.success) {
      alert("Selected items saved successfully!");
      setOpenItemsPopup(false);
      fetchDeliveryGroupData();
    } else {
      alert(data.message || "Failed to save items");
    }
  } catch (err) {
    console.error("Save items error:", err);
    alert("Something went wrong while saving items");
  }
};
const handleCancelAction = async () => {
  if (cancelType === "group") {
    await handleCancelDeliveryGroup();
  } else {
    await handleCancelOrder();
  }
};


const handleCancelDeliveryGroup = async () => {
  try {
    const fetchUrl = process.env.REACT_APP_FORE_BRICKBUCKET;
    const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);


    const response = await fetch(
      `${fetchUrl}customer/salesorder/cancel-salesorder-or-deliverygroup`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-token": token,
        },
        body: JSON.stringify({
          delivery_group_ids: selectedGroups,
        }),
      }
    );

    if (response.ok) {
      setShowCancelConfirm(false);
      fetchDeliveryGroupData();
    } else {
      console.error("Failed to cancel delivery group");
    }
  } catch (error) {
    console.error("Error cancelling delivery group:", error);
  }
};


const handleCancelOrder = async () => {
  try {
    const fetchUrl = process.env.REACT_APP_FORE_BRICKBUCKET;
    const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);


    // Replace 'selectedOrderId' with the actual variable holding your order ID
    // or use selectedOrders[0] if you are cancelling a single selection
    const response = await fetch(`${fetchUrl}customer/salesorder/cancel-salesorder-or-deliverygroup`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-token': token
      },
      body: JSON.stringify({ 
        salesorder_id: selectedOrders[0], // Example payload
        delivery_group_ids: selectedGroups,
      })
    });

    if (response.ok) {
      // toast.success("Order cancelled successfully");
      setShowCancelConfirm(false);
      fetchDeliveryGroupData(); // Refresh the list
    } else {
      console.error("Failed to cancel order");
    }
  } catch (error) {
    console.error("Error cancelling order:", error);
  }
};

  const handleCancelItem = async (itemId) => {
    const item = selectedItems.find(i => i._id === itemId);
    if (!item) return;

    const qtyToCancel = item.original_quantity - (item.available ? item.availableQty : 0);
    if (qtyToCancel <= 0) {
      alert('No quantity selected to cancel for this item');
      return;
    }

    if (!window.confirm(`Cancel quantity ${qtyToCancel} of item ${item.item_name}? This will mark the item(s) as cancelled.`)) return;

    try {
      const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);

      const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}customer/salesorder/process-refund-for-cancellation`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'x-token': token },
        body: JSON.stringify({
          items: [{ sub_order_id: item.sub_order_id, item_id: item._id, quantity: qtyToCancel }],
          reason: 'Cancelled individual item from admin UI'
        })
      });

      const data = await response.json();
      if (data.success) {
        alert('Item cancelled (refund processed if applicable)');
        // refresh orders list
        fetchDeliveryGroupData();
        setOpenItemsPopup(false);
      } else {
        alert(data.message || 'Failed to cancel item');
      }
    } catch (err) {
      console.error('Cancel item error', err);
      alert('Something went wrong while cancelling item');
    }
  };

  const handleRefundItem = async (itemId) => {
    const item = selectedItems.find(i => i._id === itemId);
    if (!item) return;

    const qtyToRefund = item.original_quantity - (item.available ? item.availableQty : 0);
    if (qtyToRefund <= 0) {
      alert('No quantity selected to refund for this item');
      return;
    }

    if (!window.confirm(`Process refund for quantity ${qtyToRefund} of item ${item.item_name}?`)) return;

    try {
      const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);

      const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}customer/salesorder/process-refund-for-cancellation`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'x-token': token },
        body: JSON.stringify({
          items: [{ sub_order_id: item.sub_order_id, item_id: item._id, quantity: qtyToRefund }],
          reason: 'Refund for partial item from admin UI'
        })
      });

      const data = await response.json();
      if (data.success) {
        alert('Refund processed successfully');
        fetchDeliveryGroupData();
        setOpenItemsPopup(false);
      } else {
        alert(data.message || 'Failed to process refund');
      }
    } catch (err) {
      console.error('Refund item error', err);
      alert('Something went wrong while processing refund');
    }
  };

  // ===== Filter orders based on search =====
  const filteredOrders = orders
    .map(order => ({
      ...order,
      filteredGroups: filterDeliveryGroups(order.delivery_groups || [], order)
    }))
    .filter(order => order.filteredGroups.length > 0);

  const hasAnyMatch = filteredOrders.length > 0;

  const {
    currentItems,
    currentPage,
    totalPages,
    totalItems,
    handlePageChange,
    handlePreviousPage,
    handleNextPage,
    resetToFirstPage
  } = usePagination(filteredOrders, 5);

  // Fetch suppliers when popup opens
  useEffect(() => {
    if (awardPopupOpen) {
      fetchSuppliers();
      console.log("Award Popup Opened");
    }
  }, [awardPopupOpen]);

  const fetchSuppliers = async () => {
    console.log("selectedItems:",selectedItems)
  try {

    setAwardLoading(true);
    const encryptedToken = sessionStorage.getItem('token');
    const token = decryptData(encryptedToken);
    const ids = selectedItems.map(item => item.item_id);

    const url = `${process.env.REACT_APP_FORE_BRICKBUCKET}vendor/get-quick-buy-suppliers-by-items?itemIds=${ids}`;

    const res = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-token": token,
      },
    });

    const data = await res.json();
    console.log(data);
    if (!data.success) {
      console.warn("Failed to fetch suppliers:", data.message);
      setSuppliers([]);
      return;
    }

    setSuppliers(data.data || []);
  } catch (error) {
    console.error("Error fetching suppliers:", error);
    setSuppliers([]);
  } finally {
    setAwardLoading(false);
  }
};

const toggleBillingSelectAll = () => {
  if (selectedBillingStatus.length === BILLING_STATUS_OPTIONS.length) {
    setSelectedBillingStatus([]);
  } else {
    setSelectedBillingStatus(BILLING_STATUS_OPTIONS);
  }
};

const toggleBillingStatus = (status) => {
  setSelectedBillingStatus(prev =>
    prev.includes(status)
      ? prev.filter(s => s !== status)
      : [...prev, status]
  );
};
const clearBillingAll = () => {
  setSelectedBillingStatus([]);
};

const handleAwardPopupOpen = () => {
  setAwardPopupOpen(true);
};

const isCancelled = (status) =>
  String(status || "").toLowerCase() === "cancelled";

  return (
    <div>
    <div className="bg-white border rounded px-2 shadow-sm ">
                            <Pagination
                                currentPage={currentPage}
                                totalPages={totalPages}
                                totalItems={totalItems}
                                itemsPerPage={5}
                                showInfo={true}
                                 hideControls={true} 
                                itemName="orders"
                            />

      {/* ===== SEARCH & FILTER ===== */}
      <div className="flex flex-wrap items-center mt-2 gap-3 mb-2">
        <div className="relative flex-1 min-w-[240px]">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
          <input
            type="text"
            placeholder="Search orders or shipments"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            className="w-full pl-10 pr-4 py-2 border rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

      <div className="relative status-dropdown">
  <Filter className="absolute left-3 top-3 w-4 h-4 text-gray-400 pointer-events-none" />

  <button
    type="button"
    onClick={() => setShowStatusDropdown(!showStatusDropdown)}
    className="pl-10 pr-8 py-2 border rounded-md text-sm bg-white focus:outline-none  min-w-[220px] text-left"
  >
    {selectedStatus.length === 0
      ? "Order Status"
      : `${selectedStatus.length} Selected`}

        <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500" />
  </button>

  {showStatusDropdown && (
    <div className="absolute z-20 mt-1 w-full bg-white border rounded-md shadow-lg">

      {/* HEADER */}
      <div className="flex items-center justify-between px-3 py-2 border-b">
        <label className="flex items-center gap-2 cursor-pointer">
          <input
            type="checkbox"
            checked={selectedStatus.length === STATUS_OPTIONS.length}
            onChange={toggleSelectAll}
          />
          <span className="text-sm font-medium">All Status</span>
        </label>

        <button
          onClick={clearAll}
          className="text-xs text-red-600 hover:underline"
        >
          Clear
        </button>
      </div>

      {/* LIST */}
      {STATUS_OPTIONS.map((status) => (
        <label
          key={status}
          className="flex items-center gap-2 px-3 py-2 hover:bg-gray-50 cursor-pointer"
        >
          <input
            type="checkbox"
            checked={selectedStatus.includes(status)}
            onChange={() => toggleStatus(status)}
          />
          <span className="text-sm">{status}</span>
        </label>
      ))}
    </div>
  )}
</div>

 <div className="relative status-dropdown">
  <Filter className="absolute left-3 top-3 w-4 h-4 text-gray-400 pointer-events-none" />

  <button
    type="button"
    onClick={() => setShowBillingStatusDropdown(!showBillingStatusDropdown)}
    className="pl-10 pr-8 py-2 border rounded-md text-sm bg-white focus:outline-none  min-w-[220px] text-left"
  >
    {selectedBillingStatus.length === 0
      ? "Billing Status"
      : `${selectedBillingStatus.length} Selected`}

        <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500" />
  </button>

  {showBillingStatusDropdown && (
    <div className="absolute z-20 mt-1 w-full bg-white border rounded-md shadow-lg">

      {/* HEADER */}
      <div className="flex items-center justify-between px-3 py-2 border-b">
        <label className="flex items-center gap-2 cursor-pointer">
          <input
            type="checkbox"
            checked={selectedBillingStatus.length === BILLING_STATUS_OPTIONS.length}
            onChange={toggleBillingSelectAll }
          />
          <span className="text-sm font-medium">All Status</span>
        </label>

        <button
          onClick={clearBillingAll }
          className="text-xs text-red-600 hover:underline"
        >
          Clear
        </button>
      </div>

      {/* LIST */}
      {BILLING_STATUS_OPTIONS.map((status) => (
        <label
          key={status}
          className="flex items-center gap-2 px-3 py-2 hover:bg-gray-50 cursor-pointer"
        >
          <input
            type="checkbox"
            checked={selectedBillingStatus.includes(status)}
            onChange={() => toggleBillingStatus(status)}
          />
          <span className="text-sm">{status}</span>
        </label>
      ))}
    </div>
  )}
</div>




      </div>

  {hasAnySelection && (
  <div className="flex justify-end mt-3 mb-2 mr-4">
    <button
  className="bg-red-600 text-white text-sm px-3 py-1.5 rounded-md"
  onClick={() => {
    if (selectedOrders.length > 0 && selectedGroups.length === selectedOrders.length) {
      setCancelType("order");
    } else {
      setCancelType("group");
    }
    setShowCancelConfirm(true);
  }}
>
  {getCancelButtonText()}
</button>
  </div>
)}


      {/* ===== ORDERS SCROLLABLE AREA ===== */}
<div className="overflow-y-auto" style={{ maxHeight: 'calc(100vh - 300px)' }}>
          {loading ? (
          <div className="text-center py-12 text-gray-500">Loading...</div>
           ) : currentItems.length === 0 ? (
    <div className="text-center rounded-lg border border-gray-100 py-16 flex flex-col items-center justify-center text-gray-500">
      <Package className="w-8 h-8 mb-2 text-gray-400" />
      <p className="text-sm font-medium">No Orders Found</p>
    </div>
        ) : !hasAnyMatch ? (
         <div className="text-center rounded-lg border border-gray-100  py-12 flex flex-col items-center justify-center text-gray-500">
  <Search className="w-6 h-6 mb-2" />
  <p className="text-sm leading-relaxed text-center">
    No matching orders found.
    <br />
    <span className="text-xs text-gray-400">
      Try adjusting your search criteria.
    </span>
  </p>
</div>
        ) : (
          currentItems.map(order => (
            <div key={order._id} className="border rounded-lg bg-white shadow-sm mb-8">
              {/* ===== ORDER HEADER ===== */}
              <div className="flex items-center justify-between px-4 py-3 bg-gray-200 border-b rounded-t-lg">
                <div className="flex items-center gap-3 w-full">
                  <input
    type="checkbox"
    disabled={isCancelled(order.status)}
    checked={selectedOrders.includes(order._id)}
    onChange={() =>
      !isCancelled(order.status) &&
      toggleOrderSelect(order._id, order.filteredGroups)
    }
    className={isCancelled(order.status) ? "cursor-not-allowed opacity-50" : ""}
  />

<div className="flex items-center w-full justify-between text-sm">
  <div className="flex items-center justify-between text-sm gap-2">
  <div className="text-gray-700 font-large">
    Order Number :{" "}
    <span className="text-gray-700 font-bold">
      {order.orderNumber}
    </span>
  </div>

    <div className="text-gray-600 flex items-center gap-1">
  <span
    className={`inline-flex px-2 py-1 rounded-full text-xs font-medium ${
      STATUS_COLORS[order.status] || "text-gray-600 bg-gray-100"
    }`}
  >
    {order.status || "-"}
  </span>
</div>

    <div className="text-gray-600">
    <span className="font-semibold">
      {new Date(order.orderDate).toLocaleDateString()}
    </span>
  </div>

  <div className="text-gray-700">
    <span className="font-semibold">
      {new Date(order.orderDate).toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      })}
    </span>
  </div>

    <div className="text-gray-700">
      <span className="font-bold text-sm">- </span>
    <span className="font-bold">
    ₹{Number(order.total || 0).toLocaleString("en-IN")}
    </span>
  </div>

</div>
<div className="text-gray-600 flex items-center justify-between gap-1">



  </div>
</div>


                </div>
              </div>

              {/* ===== SHIPMENTS TABLE ===== */}
              <div className="overflow-x-auto">
                <table className="min-w-full text-xs border-collapse">
                  <thead className="bg-white sticky top-0 z-10">
                    <tr className="text-gray-500">
                      <th className="px-4 py-2 w-10"></th>
                      <th className="px-4 py-2 text-left">Delivery Group</th>
                      <th className="px-4 py-2 text-left">Status</th>
                      <th className="px-4 py-2 text-left">Billing Status</th>
                      <th className="px-4 py-2 text-left">Items</th>
                    </tr>
                  </thead>
                  <tbody>
                    {order.filteredGroups.map(shipment => (
                    <tr key={shipment._id} className="border-t hover:bg-gray-50 transition">

                       <td className="px-4 py-2" onClick={(e) => e.stopPropagation()}>
 <input
  type="checkbox"
  disabled={isCancelled(shipment.delivery_group_status)}
  checked={selectedGroups.includes(shipment._id)}
  onChange={() => 
  !isCancelled(shipment.delivery_group_status) &&
  toggleGroupSelect(shipment._id, order)}
  className={
    isCancelled(shipment.delivery_group_status)
      ? "cursor-not-allowed opacity-50"
      : ""
  }
/>

</td>
                        <td
    className="px-4 py-2 font-medium  cursor-pointer text-blue-600 hover:underline"
    onClick={(e) => {
      e.stopPropagation();
      handleNavigateToDeliveryDetails(shipment._id, order);
    }}
  >
    {shipment.delivery_group_number}
  </td>
                        <td className="px-4 py-2">
  <span
    className={`inline-flex px-2 py-1 rounded-full text-xs font-medium ${
    STATUS_COLORS[shipment.delivery_group_status]
    }`}
  >
    {shipment.delivery_group_status}
  </span>
</td>
                       <td className="px-4 py-2">
  <span
    className={`inline-flex px-2 py-1 rounded-full text-xs font-medium ${
      STATUS_COLORS[
        shipment.billing_status || shipment.delivery_group_billing_status
      ]
    }`}
  >
    {shipment.billing_status || shipment.delivery_group_billing_status}
  </span>
</td>
                        <td className="px-4 py-2">
                          <span
                            onClick={(e) => handleItemsClick(e, shipment)}
                            className="cursor-pointer text-blue-600 font-semibold hover:underline"
                          >
                            {getTotalItemsCount(shipment)}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ))
        )}
      </div>

      {/* ===== ITEMS POPUP ===== */}
    {openItemsPopup && (
  <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center">
    {/* Increased width */}
    <div className="bg-white w-[800px] max-h-[75vh] rounded-lg shadow-lg overflow-hidden flex flex-col">

      {/* HEADER */}
      <div className="flex items-center justify-between px-4 py-3 border-b bg-gray-50">
        <h3 className="font-semibold text-gray-800">Delivery Items</h3>
        <button
          onClick={() => setOpenItemsPopup(false)}
          className="text-gray-500 hover:text-black text-lg"
        >
          ✕
        </button>
      </div>

      {/* ACTION BAR WHEN ANY ITEM SELECTED */}
     {selectedItems.some(i => i.available) && (
  <div className="px-4 py-2 border-b bg-blue-50 flex gap-3 justify-end">
    <button className="px-3 py-1 bg-green-600 text-white rounded text-sm" onClick={() => handleAwardPopupOpen()}>
      Change Supplier
    </button>

    <button className="px-3 py-1 bg-red-500 text-white rounded text-sm" onClick={handlecancelSelectedItems}>
      Remove Item(s)
    </button>
  </div>
)}

      {/* TABLE BODY */}
      <div className="p-4 max-h-[60vh] lg:max-h-[72vh] mb-6 pb-4 lg:mb-6 lg:pb-4 overflow-y-auto relative">
  <table className="w-full border-separate border-spacing-0 text-sm">
          <thead className="bg-gray-100 sticky top-0 z-[999] shadow-sm">
            <tr>
              {/* 1st Column - Available */}
              <th className="border border-gray-200 px-3 py-2 text-center w-20">
              </th>

              <th className="border border-gray-200 px-3 py-2 text-left w-24">
                Item
              </th>

              <th className="border border-gray-200 px-3 py-2 text-left">
                Item Name
              </th>

              <th className="border border-gray-200 px-3 py-2 text-center w-20">
                Quantity
              </th>

              <th className="border border-gray-200 px-3 py-2 text-center w-24">
                Available Qty
              </th>

{/*               <th className="border border-gray-200 px-3 py-2 text-center w-20">
                Vendor
              </th> */}

              <th className="border border-gray-200 px-3 py-2 text-center w-20">
                Supplier
              </th>

              <th className="border border-gray-200 px-3 py-2 text-center w-20">
                Items Status
              </th>

              {/* <th className="border border-gray-300 px-3 py-2 text-center w-32">
                Actions
              </th> */}
            </tr>
          </thead>

          <tbody>
            {selectedItems.length > 0 ? (
              selectedItems.map((item) => (
                <tr key={item._id} className={`hover:bg-gray-50`}>

                  {/* AVAILABLE FIRST */}
                  <td className="border border-gray-200 px-3 py-2 text-center">
                    <input
                      type="checkbox"
                      checked={item.available}
                      disabled={isCancelled(item.delivery_group_status) || isCancelled(item.item_status)}
                      onChange={() => 
                        (!isCancelled(item.delivery_group_status) || !isCancelled(item.item_status)) &&
                        toggleItemAvailability(item._id)}
                        className={
                        isCancelled(item.delivery_group_status) || isCancelled(item.item_status)
                          ? "cursor-not-allowed opacity-50"
                          : ""
                      }
                    />
                  </td>

                  <td className="border border-gray-200 px-3 py-2">
                    <div className="w-10 h-10 bg-gray-100 rounded flex items-center justify-center text-xs text-gray-400">
                      {item.item_image ? (
                        <img
                          src={process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES + item.item_image}
                          alt="Item"
                          className="w-full h-full object-cover rounded"
                        />
                      ) : (
                        <span className="inline-flex w-10 h-10 bg-gray-100 rounded items-center justify-center text-xs text-gray-400 text-center">
                          No<br />Image
                        </span>
                      )}
                    </div>
                  </td>

                  <td className="border border-gray-200 px-3 py-2 text-gray-800">
                    {item.item_name}
                  </td>

                  <td className="border border-gray-200 px-3 py-2 text-center font-medium">
                    {item.original_quantity}
                  </td>

                  {/* INPUT FIELD FOR AVAILABLE QTY */}
                <td className="border border-gray-200 px-3 py-2 text-center">
                <input
                  type="number"
                  value={item.availableQty ?? ""}
                  disabled={true} // Disable direct input
                  onChange={(e) =>
                    setItemAvailableQty(item._id, e.target.value)
                  }
                  className="w-20 text-center px-2 py-1 border rounded"
                  placeholder=""
                />
                </td>

{/*                   <td className="border border-gray-200 px-3 py-2 text-center font-medium">
                    {item.item_vendor?.company_name || "-"}
                  </td> */}

                  <td className="border border-gray-200 px-3 py-2 text-center font-medium">
                    {item.supplier?.company_name || "-"}
                  </td>

                  <td className="border border-gray-200 px-3 py-2 text-center font-medium">
                    {item?.item_status || "-"}
                  </td>

                  {/* <td className="border border-gray-300 px-3 py-2 text-center">
                    <div className="flex items-center gap-2 justify-center">
                      <button
                        onClick={() => handleCancelItem(item._id)}
                        className="px-2 py-1 bg-red-600 text-white text-xs rounded"
                      >
                        Cancel
                      </button>

                      <button
                        onClick={() => handleRefundItem(item._id)}
                        className="px-2 py-1 bg-yellow-600 text-white text-xs rounded"
                      >
                        Refund
                      </button>
                    </div>
                  </td> */}
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={8}
                  className="border border-gray-200 px-4 py-6 text-center text-gray-500"
                >
                  No items found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* FOOTER SAVE BUTTON */}
{/*     {selectedItems.some(i => i.available) && (
  <div className="border-t px-4 py-3 flex justify-end gap-2">
    <button
      className="px-4 py-1 bg-blue-600 text-white rounded"
     onClick={handlesaveSelectedItems}
    >
      Save
    </button>
  </div>
)} */}

    </div>
  </div>
)}

{showCancelConfirm && (
  <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 p-4">
    <div className="bg-white w-full max-w-[340px] rounded-xl shadow-2xl overflow-hidden">
      {/* Header - Compact spacing */}
      
      {/* Body - Reduced padding and centered text for smaller footprint */}
     <div className="px-6 pt-6 pb-2 text-center text-md text-gray-700">
 <p className="font-medium">
  {cancelType === "group"
    ? "Are you sure you want to cancel the selected delivery group?"
    : "Are you sure you want to cancel the selected order?"}
</p>
</div>

      {/* Footer - Compacted spacing */}
      <div className="px-6 py-5 flex justify-center gap-3">
        <button
          onClick={() => setShowCancelConfirm(false)}
          className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium hover:bg-gray-50 transition-colors"
        >
          No
        </button>

        <button
         onClick={handleCancelAction}
          className="flex-1 px-4 py-2 bg-red-600 text-white rounded-lg text-sm font-medium hover:bg-red-700 transition-colors"
        >
          Yes
        </button>
      </div>

    </div>
  </div>
)}

{awardPopupOpen && (
  <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4">
    <div className="bg-white w-full max-w-lg p-6 rounded-xl shadow-xl">

      <h3 className="text-lg font-bold text-gray-800 mb-3">
        Change Suppliers
      </h3>

      <p className="text-sm text-gray-600 mb-4">
        Select suppliers who can supply the items.
      </p>

      {/* ===== SUPPLIER LIST CONTAINER ===== */}
      <div className="max-h-60 overflow-y-auto border rounded-lg bg-gray-50">

        {suppliers.length === 0 ? (

          <p className="text-gray-500 text-center py-6">
            No suppliers available
          </p>

        ) : (

          suppliers.map((s) => (

            <div
              key={s._id}
              className="flex items-center p-3 border-b hover:bg-gray-100"
            >

              <input
                type="checkbox"
                checked={selectedSuppliers.includes(s._id)}
                onChange={() => toggleSupplierSelection(s._id)}
                className="mr-3"
              />

              <div>
                <p className="font-medium">
                  {s?.company_name}
                </p>

                <p className="text-xs text-gray-600">
                  {s?.mobile_number}
                </p>
              </div>

            </div>

          ))

        )}

      </div>

      {/* ===== BUTTONS ===== */}
      <div className="flex justify-end gap-2 mt-5">

        <button
          className="px-3 py-1 bg-gray-300 rounded"
          onClick={() => setAwardPopupOpen(false)}
        >
          Close
        </button>

        <button
        onClick={handleAwardSupplier}

          className={`
            px-3 py-1 rounded text-white
            ${
              selectedSuppliers.length === 0
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-blue-600 hover:bg-blue-700"
            }
          `}
        >
          Award
        </button>

      </div>

    </div>
  </div>
)}
</div>

<div className="bg-white absolute bottom-4 left-0 w-full z-30 px-4 py-2 shadow-sm pb-6 mb-2">
      <Pagination
    currentPage={currentPage}
    totalPages={totalPages}
    totalItems={totalItems}
    itemsPerPage={5}
    onPageChange={handlePageChange}
    onPreviousPage={handlePreviousPage}
    onNextPage={handleNextPage}
    showInfo={false}
    itemName="Orders"
  />
</div>

    </div>
  );
}
